import { useCallback, useEffect, useState } from 'react';
import './style.scss';
import CustomDropZone from '../../common/CustomDropZone';
// import Stepper from '../../common/Stepper/Stepper';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { updateStepWiseUserData } from '../../redux/Reducers/userStepsDataDetailReducer';
import { useDispatch } from 'react-redux';
import SelectSingleImage from '../../common/SelectSingleImage';
import { v4 as uuid } from 'uuid';
import { message } from 'antd';
import DynamicModal from '../../common/DynamicModal/DynamicModal';
import EmailModal from '../EmailModal';
import miscApi from '../../apis/misc';
import useCreditContext from '../../hooks/useCreditContext';
import useAuthContext from '../../hooks/useAuthContext';
import { useGenerateResponseForNimbus } from '../../hooks/useGenerate';
import { isNumber } from 'lodash';
import NotEnoughCredit from '../NotEnoughCredit';


const { getMultipleCostCreditGeneration } = miscApi;

const Step_Upload_Images = () => {
  const navigate = useNavigate();
  const numberOfImagesToUpload = 100;
  const allowedExtensions = ['jpg', 'jpeg', 'png', 'webp'];
  const [showModal, setShowModal] = useState(false);
  const [generateBtnClicked, setGenerateBtnClicked] = useState(false);
  const [availableCredits, setAvailableCredits] = useState(0);
  const [creditsRequired, setCreditsRequired] = useState(0);
  const [isLoggedInByGenerate, setIsLoggedInByGenerate] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const uploaded_files = useSelector(
    (state) => state.userStepsDataDetailReducer.stepUploadImages.files
  );


  const {
    credits: { free: freeCredits, paid: paidCredits },
    refetchCredits,
  } = useCreditContext();

  const fetchCreditsOnChange = useCallback(async () => {
    let payloadData = {
      requestType: 'modelClipper',
      "notificationMetaData": {
        "emailIds": JSON.parse(localStorage.getItem('mm:user'))?.userEmail
      },
      inputFiles: getModifiedPayloadForInputFiles(),
    } || [];
    try {
      const res = await getMultipleCostCreditGeneration(payloadData);
      let costCalc = res.data.costArray.reduce(
        (acc, cost) => acc + Number(cost.totalCost),
        0
      );
      setCreditsRequired(costCalc);
    } catch (err) {
      message.error(err);
    }
  }, [uploaded_files]);

  useEffect(() => {
    fetchCreditsOnChange();
  }, [
    uploaded_files,
    isLoggedInByGenerate,
    fetchCreditsOnChange,
  ]);

  useEffect(() => {
    !!isAuthenticated && !!userToken && refetchCredits();
  }, []);

 

  useEffect(() => {
    let avCredit =
      (freeCredits ? freeCredits : 0) + (paidCredits ? paidCredits : 0);
    setAvailableCredits(
      (freeCredits ? freeCredits : 0) + (paidCredits ? paidCredits : 0)
    );
    if (isNumber(avCredit)) {
      if (avCredit >= 0 && creditsRequired > 0 && creditsRequired > avCredit) {
        console.log('available', avCredit);
        // setShowLoginModal(false);
        setOpenModal(true);
        setIsLoggedInByGenerate(false);
        generateBtnClicked && handleCreditsPopup();
        return;
      }
      if (
        avCredit > 0 &&
        creditsRequired > 0 &&
        avCredit > creditsRequired &&
        isLoggedInByGenerate
      ) {
        // setShowLoginModal(false);
        setShowModal(true);
        handleGenerateBtn(avCredit, creditsRequired);
        setIsLoggedInByGenerate(false);
      }
    }
  }, [
    freeCredits,
    paidCredits,
    creditsRequired,
    isLoggedInByGenerate,
    generateBtnClicked,
    handleGenerateBtn,
  ]);


  function modifiedResponseForTask(taskList) {
    let responseArray = taskList?.map((item, index) => {
      return {
        taskId: item?._id,
        isLoading: true,
        isFailed: false,
        isSuccess: false,
        responseUrl: '',
        responsekey: '',
        inputImage: '',
        outputImage: '',
        input: item?.input,
        output: null,
        isEdited: false,
        isEditing: false,
        index,
      };
    });

    return responseArray;
  }

  function onSuccessGenerateItems(data) {
    dispatch(
      updateStepWiseUserData({
        stepZero: {},
        stepUploadImages: {
          isAllImagesUploaded: false,
          files: [],
        },

        stepGenerateImage: {
          generatedResponse: [
            // ...generatedModifiedResponse,
            ...modifiedResponseForTask(data?.data?.data?.request?.tasks),
          ],
        },
      })
    );
    setGenerateBtnClicked(true);
    navigate('/dashboard');
  }

  function onErrorGenerateItems(err) {
    message.error(err?.response?.message);
    setGenerateBtnClicked(false);
  }

  const { mutate: handleGenerateMM } = useGenerateResponseForNimbus(
    onSuccessGenerateItems,
    onErrorGenerateItems
  );

  const getModifiedPayloadForInputFiles = () => {
    let files = [...uploaded_files];
    let outputPayload = files?.map((itm) => {
      return {
        imagePath: {
          key: itm?.generatedKey,
        },
      };
    });

    return outputPayload;
  };

  async function handleGenerateBtn(avalCredit, RequiredCrdt) {
    
    if (RequiredCrdt > avalCredit) {
      handleCreditsPopup();
    }
    
    if (avalCredit > 0 && !!isAuthenticated && !!userEmail) {
      setShowModal(true);
      setGenerateBtnClicked(true);
      let payload = {
        requestType: 'modelClipper',
        "notificationMetaData": {
          "emailIds": JSON.parse(localStorage.getItem('mm:user')).userEmail
        },
        inputFiles: getModifiedPayloadForInputFiles(),
      };
      handleGenerateMM(payload);

    }
  }

  const handleCreditsPopup = () => {
    setOpenModal(true);
  };

  const getCreditsPopup = () => {
    return (
      <DynamicModal
        open={openModal}
        closable={true}
        close={() => setOpenModal(false)}
        footer={null}
        width={'100%'}
        height={'100%'}
        classWrapper="no_credits"
        component={
          <NotEnoughCredit
            setOpenModal={setOpenModal}
            availableCredits={freeCredits ?? 0 + paidCredits ?? 0}
            requiredCredits={creditsRequired}
          />
        }
      />
    );
  };

  const {
    user: { userEmail, userToken },
    isAuthenticated,
  } = useAuthContext();

  

  const dispatch = useDispatch();



  const [isDragging, setIsDragging] = useState(false);



  const handleDragEnter = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const onDropItems = (files) => {
    // if (uploaded_files?.length + files?.length > numberOfImagesToUpload) {
    //   message.error(
    //     `You cannot upload images more than ${numberOfImagesToUpload}`
    //   );
    //   setIsDragging(false);
    //   return;
    // }
    let hasError = false;
    let modifiedList = files.map((file) => {
      if (file) {
        const fileExtension = file?.name.split('.').pop().toLowerCase();
        if (!allowedExtensions.includes(fileExtension)) {
          message.error('please upload images only');
          hasError = true;
          return null;
        }
      }
      return {
        isFailed: false,
        isSuccess: false,
        isLoading: true,
        file: file,
        imagePreview: URL.createObjectURL(file),
        _id: uuid(),
        generatedUrl: '',
        generatedKey: '',
        thumbImageUrl: '',
        fileName: file?.name,
        fileType: file?.type,
      };
    });
    if (hasError) {
      navigate('/upload-images');
      return;
    }
    dispatch(
      updateStepWiseUserData({
        stepUploadImages: {
          isAllImagesUploaded: false,
          files: [...uploaded_files, ...modifiedList],
        },
      })
    );

    setIsDragging(false);
  };

  const handleUploadImages = (files) => {
   
    let hasError = false;
    let modifiedList = files?.map((file) => {
      if (file) {
        const fileExtension = file?.name.split('.').pop().toLowerCase();
        if (!allowedExtensions.includes(fileExtension)) {
          message.error('please upload images only');
          hasError = true;
          return null;
        }
      }
      return {
        isFailed: false,
        isSuccess: false,
        isLoading: true,
        file: file,
        imagePreview: URL.createObjectURL(file),
        _id: uuid(),
        generatedUrl: '',
        generatedKey: '',
        thumbImageUrl: '',
        fileName: file?.name,
        fileType: file?.type,
      };
    });
    if (hasError) {
      navigate('/upload-images');
      return;
    }

    dispatch(
      updateStepWiseUserData({
        stepUploadImages: {
          isAllImagesUploaded: false,
          files: [...uploaded_files, ...modifiedList],
        },
      })
    );
  };

  const isAllSuccess = uploaded_files.every((file) => file.isSuccess);
  const isAllLoading = uploaded_files.every((file) => file.isLoading);

  // 
  const getFileCount = () => {
    return (
      uploaded_files?.length > 0 && (
        <div className="overlay_count_container">
          {uploaded_files?.length} {" "}
          {uploaded_files?.length == 1 ? 'image ' : 'images'} uploaded
        </div>
      )
    );
  };

  const renderEmailPopup = useCallback(
    () => (
      <DynamicModal
        open={showModal}
        closable={true}
        close={() => {
          setShowModal(false);
        }}
        footer={null}
        width={'auto'}
        classWrapper="tips_wrapper"
        component={<EmailModal
          setShowModal={setShowModal}
          availableCredits={availableCredits}
          creditsRequired={creditsRequired}
          handleGenerateBtn={handleGenerateBtn}
        />}
      />
    ),
    [showModal]
  );
 


  return (
    <div className="upload_show_images_main_wrapper">
      <div className="images_collections_wrapper">
        <div className="btn_info_row">
          <label className="upload_more_images_btn" htmlFor="file">
            + Upload multiple images
            <input
              type="file"
              accept="image/png,image/jpg,image/jpeg, image/webp"
              id="file"
              onChange={(e) => handleUploadImages([...e.target.files])}
              onClick={(e) => {
                e.target.value = null;
              }}
              className="upload_more_images_btn_input"
              multiple
            />
          </label>
          <span className="uploaded_images_count">
            {uploaded_files?.length} {" "}
            {uploaded_files?.length == 1 ? 'image ' : 'images'} uploaded
          </span>
        </div>
        <div className="wrapper" onDragEnter={handleDragEnter}>
          {isDragging ? (
            <CustomDropZone
              dropZoneClass={'uploaded_images_row'}
              onDropItems={onDropItems}
              isShowTextOnDrag={true}
              acceptingFormates={{
                'image/jpg': [],
                'image/png': [],
                'image/jpeg': [],
                'image/webp': [],
              }}
              handleDragLeave={handleDragLeave}
            />
          ) : (
            ''
          )}

          <div className="upload_images_container">
            {uploaded_files?.map((image, index) => {

              return <SelectSingleImage item={image} isDelete={true} showLoadingText={true} />;
            })}
          </div>
          {getFileCount()}
        </div>
      </div>
      {/* {getStepper()} */}
      <div className='btn_upload'>
        {isAllSuccess && <button onClick={() => {
          if (availableCredits === 0) {
            setOpenModal(true);  
          } else {
            setShowModal(true); 
          }
          if(!isAuthenticated && !userEmail){
            navigate('/login');
          }
        }}>Submit</button>}
      </div>
      {showModal && renderEmailPopup()}
      {availableCredits === 0 && openModal && getCreditsPopup()}

    </div>
  );
};

export default Step_Upload_Images;
